<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify';

import { useSnackbarStore } from '@/stores/snackbarStore.ts';

import type { SnackbarProps } from '@/types/components/ui/snackbar.type.ts';

const snackbar = useSnackbarStore()

const snackbarProps = computed<SnackbarProps>(() => {
  const theme = useTheme()
  const color: string = theme.current.value.colors[snackbar.color] as string

  const lightenColor = (hex: string, percent = 0.88) => {
    let r = parseInt(hex.slice(1, 3), 16)
    let g = parseInt(hex.slice(3, 5), 16)
    let b = parseInt(hex.slice(5, 7), 16)

    r = Math.min(255, r + Math.round((255 - r) * percent))
    g = Math.min(255, g + Math.round((255 - g) * percent))
    b = Math.min(255, b + Math.round((255 - b) * percent))

    return `rgb(${r}, ${g}, ${b})`
  }

  let icon: string = 'Ph'

  switch (snackbar.color) {
    case 'success':
      icon += 'Check'
      break
    case 'warning':
      icon += 'Warning'
      break
    case 'error':
      icon += 'X'
      break
    default:
      icon += 'Warning'
  }

  return {
    backgroundColor: `${lightenColor(color)}`,
    color: `text-${snackbar.color}`,
    icon
  }
})
</script>

<template>
  <v-snackbar
    v-model="snackbar.visible"
    :color="snackbarProps.backgroundColor"
    variant="flat"
    location="top right"
    :content-class="snackbarProps.color"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-3" :icon="snackbarProps.icon"/>
      <p>{{ snackbar.text }}</p>
    </div>
  </v-snackbar>
</template>
